import styled, { css } from 'styled-components'

export const Stepper = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin: 40px auto 0 auto;
  position: relative;
  width: max-content;
`

export const StepContainer = styled.div`
  ${({ display }) => css`
    position: relative;
    align-items: center;
    display: ${display || 'flex'};
    flex-direction: column;
    width: 95px;
    text-align: center;
    gap: 6px;
    align-self: baseline;

    & img {
      max-width: 20px;
    }

    & svg {
      margin-top: 5px;
    }
  `}
`

export const Circle = styled.div`
  ${({ filling }) => css`
    background-color: ${filling ? '#BE9137' : '#C4C4C4'};
    border-radius: 100%;
    height: 20px;
    width: 20px;
  `}
`

export const Line = styled.div`
  position: absolute;
  background: #000;
  height: 1px;
  top: 9px;
  left: 57px;
  width: 77px;
`
